module.exports = __webpack_public_path__ + "static/media/SO.d3dc6e36.pdf";